import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_PATIENT_EXERCISES_BY_ID_KEY } from '_api/queries/exercise/useGetAllPatientExercisesByID';
import { AddExerciseToPatientPayload } from '_api/types';

export const UPDATE_EXERCISE_TO_PATIENT_KEY = 'update-exercise-to-patient';

export const useUpdateExerciseToPatient = () => {
  const queryClient = useQueryClient();
  return useApiMutation<AddExerciseToPatientPayload, AddExerciseToPatientPayload>(
    () => '/exercise/update-patient-exercise-setting',
    'put',
    {},
    {
      mutationKey: [UPDATE_EXERCISE_TO_PATIENT_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_PATIENT_EXERCISES_BY_ID_KEY],
        });
      },
    },
  );
};
